<div class="container">
    <div class="row">
        <div class="col mb-3 text-center">
            <h4 class="h4">
                You've added a customizable box to your cart.
            </h4>
            <p>To make changes:</p>
            <ul class="list-unstyled text-start m-auto" [class.w-75]="!isMobile()">
                <li><b class="text-secondary">1.</b> Tap <b>Customize Now</b>—or customize later from your cart.</li>
                <li><b class="text-secondary">2.</b> Remove any item you don't want.</li>
                <li><b class="text-secondary">3.</b> Go to <b>Add-Ons</b> tab to choose a replacement.</li>
                <li><b class="text-secondary">4.</b> Tap <b>Done Customizing</b> to update your box.</li>
            </ul>
        </div>
    </div>

    <div class="row mt-0 m-3 justify-content-center">
        <div class="col-6 col-lg-4 col-md-6">
            <button type="button" class="btn w-100 btn-primary" (click)="closeModal()" [routerLink]="customBoxUrl()">
                Customize Now
            </button>
        </div>
        <div class="col-6 col-lg-4 col-md-6">
            <button type="button" class="btn w-100 btn-outline-primary" (click)="openCart()">
                Go To Cart
            </button>
        </div>
    </div>
</div>